import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-md-6 offset-md-3" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "business-unit-name" }, "BusinessUnit Name:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "business-unit-parent" }, "BusinessUnit Parent:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select parent unit", -1)
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Add BusinessUnits",
    onConfirm: _ctx.addBusinessUnit,
    onCancel: _ctx.cancelAddBusinessUnit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-lg",
                id: "business-unit-name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newName) = $event)),
                placeholder: "Enter business unit name"
              }, null, 512), [
                [_vModelText, _ctx.newName]
              ]),
              _hoisted_5,
              _withDirectives(_createElementVNode("select", {
                class: "form-control form-control-lg",
                id: "business-unit-parent",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newParent) = $event))
              }, [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (businessUnit) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: businessUnit.id,
                    value: businessUnit
                  }, _toDisplayString(businessUnit.name), 9, _hoisted_7))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.newParent]
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary mx-auto d-block",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addBusinessUnit && _ctx.addBusinessUnit(...args)))
            }, "Create")
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onConfirm", "onCancel"]))
}